import client from 'helpers/client';
import cognito from 'helpers/cognito';

/**
 * NFT License API utilities for app
 */

// Get NFT Licenses by codebase
export const getNFTLicenses = async (codebaseId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      codebaseId,
      ...filters
    });
    
    const response = await client.api(`/nft-licenses?${params}`, 'get', {
      headers: await cognito.getHeaderAuthorization()
    });
    
    return response;
  } catch (error) {
    console.error('Error getting NFT licenses:', error);
    throw error;
  }
};

// Revoke NFT License
export const revokeNFTLicense = async (id, revokeReason = '') => {
  try {
    // For DELETE with body, we need to pass data as 3rd param and headers as 4th param
    const data = revokeReason ? { revokeReason } : null;
    const response = await client.api(
      `/nft-licenses/${id}`, 
      'delete', 
      data,
      {
        headers: await cognito.getHeaderAuthorization()
      }
    );
    
    return response;
  } catch (error) {
    console.error('Error revoking NFT license:', error);
    throw error;
  }
};

// Send renewal reminder email to buyer
export const sendRenewalReminder = async (id) => {
  try {
    const response = await client.api(`/nft-licenses/${id}/send-renewal-reminder`, 'post', {}, {
      headers: await cognito.getHeaderAuthorization()
    });
    
    return response;
  } catch (error) {
    console.error('Error sending renewal reminder:', error);
    throw error;
  }
};

// Get analytics
export const getNFTLicenseAnalytics = async (codebaseId = null) => {
  try {
    const params = codebaseId ? `?codebaseId=${codebaseId}` : '';
    const response = await client.api(`/nft-licenses/analytics/summary${params}`, 'get', {
      headers: await cognito.getHeaderAuthorization()
    });
    
    return response;
  } catch (error) {
    console.error('Error getting NFT license analytics:', error);
    throw error;
  }
};

// Create NFT License (when minting)
export const createNFTLicense = async (data) => {
  try {
    const response = await client.api('/nft-licenses', 'post', data, {
      headers: await cognito.getHeaderAuthorization()
    });
    
    return response;
  } catch (error) {
    console.error('Error creating NFT license:', error);
    throw error;
  }
};

export default {
  getNFTLicenses,
  revokeNFTLicense,
  sendRenewalReminder,
  getNFTLicenseAnalytics,
  createNFTLicense,
};

